import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Protect } from '@clerk/clerk-react';

import FeedOverview from './FeedOverview';
import InventoryItem from './InventoryItem';
import Inventory from './InventoryManagement/InventoryViewer';
import AccessDenied from '../errors/AccessDenied';

export const InventoryLayout = () => {
	return (
		<Protect permission="org:inventory:read" fallback={<AccessDenied />}>
			<Outlet />
		</Protect>
	);
};

export const inventoryRoutes = [
	// shop only
	{ path: ':shopId', element: <Navigate to="feed" replace /> },
	{ path: ':shopId/feed', element: <FeedOverview /> },
	//chain only
	{ index: true, element: <Navigate to="items" replace /> },
	{ path: 'feed', element: <Navigate to="/inventory/items" replace /> },
	// both
	{
		path: ':shopId?',
		children: [
			{ path: 'items', element: <Inventory /> },
			{ path: 'items/:barcode', element: <InventoryItem /> }
		]
	}
];
